import { createRoot } from 'react-dom/client';

// Import polyfills first
import './lib/polyfills.ts';

// Suppress the THREE.Clock deprecation warning from @react-three/fiber v9 internals.
// R3F v10 replaces Clock with Timer (https://github.com/pmndrs/react-three-fiber/issues/3741)
// but is still alpha. Remove this filter once @react-three/fiber ≥ 10.0.0 stable is installed.
if (typeof window !== 'undefined') {
  const _warn = console.warn;
  console.warn = (...args: unknown[]) => {
    if (typeof args[0] === 'string' && args[0].includes('THREE.Clock')) return;
    _warn.apply(console, args);
  };
}

// Import Inter font
import '@fontsource-variable/inter';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
